// 컴포넌트
import MainBanner from './sub/mainBanner';
import MainSlider from './sub/mainSlider';

import MostPopular from './components/mostPopular';
import BannerStatic from './components/bannerStatic';
import BannerSlide from './components/bannerSlide';
import BannerGridSlide from './components/bannerGridSlide';
import FoundationBoardTable from './components/foundationBoardTable';
import YoutubeSlide from './components/youtubeSlide';
import BannerLine from './components/bannerLine';
import EditorPick from './components/editorPick';
import EditorPickYoutube from './components/editorPickYoutube';
import EditorPickEpisode from './components/editorPickEpisode';
import RecommendProgram from './components/recommendProgram';
import News from './components/news';
import Schedule from './components/schedule';

function Main() {
  return (
    <div id="Main" className="main">
      <section className="main_section slider">
        <MainBanner />
        <MainSlider />
      </section>
      <section className="main-section__schedule">
        <Schedule />
      </section>
      <section className="main-section__news">
        <News />
      </section>
      <section className="main-section__recommend-program">
        <RecommendProgram />
      </section>
      <section className="main-section__most-popular">
        <MostPopular />
      </section>
      <section className="main-section__editor-pick episode">
        <EditorPickEpisode />
      </section>
      <section className="main-section__editor-pick youtube">
        <EditorPickYoutube />
      </section>
      <section className="main-section__editor-pick vod">
        <EditorPick />
      </section>
      <section className="main-section__banner-line">
        <BannerLine />
      </section>
      <section className="main-section__youtube-slide">
        <YoutubeSlide />
      </section>
      <section className="main-section__foundation">
        <FoundationBoardTable />
        <BannerGridSlide />
      </section>
      <section className="main-section__banner-static">
        <BannerStatic />
      </section>
      <section className="main-section__banner-slide">
        <BannerSlide />
      </section>
    </div>
  );
}

export default Main;
